import { IBodyTripSelected } from "models/TripInterface";
import { postAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";

export function payTmbActivity(
  body: any,
  callback: Function,
  errorCallback: Function
) {
  postAxios(apiNames.BKING, true, `/tmb/bookings`, body)
    .then((data: any) => {
      callback(data);

    })
    .catch((error: any) => {
      errorCallback(error);
    });
}

export function payTmbActivityCIT(
  body: any,
  callback: Function,
  errorCallback: Function
) {
  postAxios(apiNames.BKING, true, `/tmb/bookings/cit`, body)
    .then((data: any) => {
      callback(data);

    })
    .catch((error: any) => {
      errorCallback(error);
    });
}

